/**
 * Validate if the value is in the list and return the value or empty string
 * Useful for validating enums
 */
export function validateValueInType<T>(
  value: string,
  list: readonly string[],
): T {
  if (list.includes(value)) {
    return value as T;
  } else {
    return '' as T;
  }
}
